// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tracking-detail {
    padding: 3rem 0
}

#tracking {
    margin-bottom: 1rem
}

[class*=tracking-status-] p {
    margin: 0;
    font-size: 1.1rem;
    color: #fff;
    text-transform: uppercase;
    text-align: center
}

[class*=tracking-status-] {
    padding: 1.6rem 0
}

.tracking-status-intransit {
    background-color: #65aee0
}

.tracking-status-outfordelivery {
    background-color: #f5a551
}

.tracking-status-deliveryoffice {
    background-color: #f7dc6f
}

.tracking-status-delivered {
    background-color: #4cbb87
}

.tracking-status-attemptfail {
    background-color: #b789c7
}

.tracking-status-error,
.tracking-status-exception {
    background-color: #d26759
}

.tracking-status-expired {
    background-color: #616e7d
}

.tracking-status-pending {
    background-color: #ccc
}

.tracking-status-inforeceived {
    background-color: #214977
}

.tracking-list {
    border: 1px solid #e5e5e5
}

.tracking-item {
    border-left: 1px solid #e5e5e5;
    position: relative;
    padding: 2rem 1.5rem .5rem 2.5rem;
    font-size: .9rem;
    margin-left: 3rem;
    min-height: 5rem
}

.tracking-item:last-child {
    padding-bottom: 4rem
}

.tracking-item .tracking-date {
    margin-bottom: .5rem
}

.tracking-item .tracking-date span {
    color: #888;
    font-size: 85%;
    padding-left: .4rem
}

.tracking-item .tracking-content {
    padding: .5rem .8rem;
    background-color: #f4f4f4;
    border-radius: .5rem
}

.tracking-item .tracking-content span {
    display: block;
    color: #888;
    font-size: 85%
}

.tracking-item .tracking-icon {
    line-height: 2.6rem;
    position: absolute;
    left: -1.3rem;
    width: 2.6rem;
    height: 2.6rem;
    text-align: center;
    border-radius: 50%;
    font-size: 1.1rem;
    background-color: #fff;
    color: #fff
}

.tracking-item .tracking-icon.status-sponsored {
    background-color: rgb(43, 162, 188)
}

.tracking-item .tracking-icon.status-delivered {
    background-color: #4cbb87
}

.tracking-item .tracking-icon.status-outfordelivery {
    background-color: #f5a551
}

.tracking-item .tracking-icon.status-deliveryoffice {
    background-color: #f7dc6f
}

.tracking-item .tracking-icon.status-attemptfail {
    background-color: #b789c7
}

.tracking-item .tracking-icon.status-exception {
    background-color: #d26759
}

.tracking-item .tracking-icon.status-inforeceived {
    background-color: #214977
}

.tracking-item .tracking-icon.status-intransit {
    color: #e5e5e5;
    border: 1px solid #e5e5e5;
    font-size: .6rem
}

@media(min-width:992px) {
    .tracking-item {
        margin-left: 10rem
    }

    .tracking-item .tracking-date {
        position: absolute;
        left: -10rem;
        width: 7.5rem;
        text-align: right
    }

    .tracking-item .tracking-date span {
        display: block
    }

    .tracking-item .tracking-content {
        padding: 0;
        background-color: transparent
    }
}

/*  //old ind */

.track-info h3 {
    font-size: 18px;
    color: #1B1E1A;
    margin-bottom: 30px
}

.track-info ul {
    padding: 0;
    margin: 0
}

.track-info ul li {
    position: relative;
    letter-spacing: .35px
}

.track-info ul li ul {
    width: 80%
}

.track-info ul li ul li {
    display: grid;
    grid-template-columns: 120px 1fr;
    padding: 15px 0;
    font-size: 12px;
    color: #6f6f6f;
    font-weight: 400
}

.track-info ul li ul li::before {
    top: 20px;
    left: -30px;
    position: absolute;
    width: 12px;
    height: 2px;
    background: #959595;
    content: ""
}

.track-info ul li ul li h4 {
    margin: 0
}

.track-info ul li ul li strong,
.track-info ul li ul li h4 {
    color: #1B1E1A;
    font-weight: 500
}

.track-info ul li ul li strong {
    display: inline-block;
    margin-bottom: 6px
}

.track-info ul li ul li b {
    display: block;
    color: #1B1E1A;
    font-size: 13px;
    font-weight: 500;
    margin-bottom: 5px
}

.track-info>ul>li {
    font-size: 16px;
    font-weight: 700;
    padding-left: 30px;
    border-left: 2px solid #959595;
}

.track-info>ul>li::before {
    top: 0 !important;
}

.track-info>ul>li:last-child::after {
    bottom: -1px
}


.track .track-info>ul>li:last-child::after,
.track .track-info>ul>li::before {
    content: "";
    height: 18px;
    width: 18px;
    background: #959595;
    border: 3px solid #fff;
    border-radius: 50%;
    position: absolute;
    left: -10px
}

.tracking_error {
    padding: 15px;
    font-weight: 500;
    margin-top: 15px;
    background: #ff2828;
    text-align: center !important;
    color: #fff !important;
    border-radius: 4px
}

.track-not-found {
    text-align: center;
    margin-top: 15px
}

.track-not-found::before {
    content: "";
    /* background: url(/wp-content/themes/ecourier-2.0/images/not-found.svg) no-repeat center center; */
    -ms-background-size: 100%;
    background-size: 100%;
    width: 150px;
    height: 150px;
    display: block;
    margin: 30px auto
}

.track-not-found h3 {
    color: #1B1E1A;
    margin-bottom: 5px
}

.track-not-found h4 {
    color: #3a3a3a;
    font-weight: 400
}

.track-info>ul>li.active::before,
.track-info>ul>li.active:last-child::after {
    background: #0098b8;
}
.track-info>ul>li.active {
    border-color: #0098b8;
}

.track-info>ul>li.active::before,
.track-info>ul>li.active:last-child::after {
    background: #0098b8;
}

.track-info>ul>li.active ul li::before {
    background: #0098b8 !important;
}

.track .track-info>ul>li:last-child::after,
.track .track-info>ul>li::before {
    content: "";
    height: 18px;
    width: 18px;
    background: #0098b8;
    border: 3px solid #fff;
    border-radius: 50%;
    position: absolute;
    left: -10px;
}

.track-info>ul>li::before {
    top: 0;
}

*,
*::before,
*::after {
    box-sizing: border-box;
}

.track-info>ul>li {
    font-size: 16px;
    font-weight: 700;
    padding-left: 30px;
    border-left: 2px solid #959595;
}

.track-info ul li {
    position: relative;
    letter-spacing: .35px;
}

li {
    list-style: none;
}

li {
    text-align: -webkit-match-parent;
}

ul {
    list-style-type: disc;
}

.track-info ul li {
    position: relative;
    letter-spacing: .35px;
}

.track-content {
    padding: 30px;
    background: #fff;
    border-radius: 6px;
    padding-top: 10px;
}

.track {
    position: relative;
    z-index: 1;
}`, "",{"version":3,"sources":["webpack://./src/assets/Css/tracking.css"],"names":[],"mappings":"AAAA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,iCAAiC;IACjC,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,cAAc;IACd;AACJ;;AAEA;IACI,oBAAoB;IACpB,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd,WAAW;IACX;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,aAAa;QACb;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;AACJ;;AAEA,eAAe;;AAEf;IACI,eAAe;IACf,cAAc;IACd;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,eAAe;IACf,eAAe;IACf,cAAc;IACd;AACJ;;AAEA;IACI,SAAS;IACT,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,cAAc;IACd,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI;AACJ;;;AAGA;;IAEI,WAAW;IACX,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB;AACJ;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,6BAA6B;IAC7B,sBAAsB;IACtB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,WAAW;IACX,mGAAmG;IAEnG,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;IACZ,aAAa;IACb,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;;IAEI,mBAAmB;AACvB;AACA;IACI,qBAAqB;AACzB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,MAAM;AACV;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd","sourcesContent":[".tracking-detail {\n    padding: 3rem 0\n}\n\n#tracking {\n    margin-bottom: 1rem\n}\n\n[class*=tracking-status-] p {\n    margin: 0;\n    font-size: 1.1rem;\n    color: #fff;\n    text-transform: uppercase;\n    text-align: center\n}\n\n[class*=tracking-status-] {\n    padding: 1.6rem 0\n}\n\n.tracking-status-intransit {\n    background-color: #65aee0\n}\n\n.tracking-status-outfordelivery {\n    background-color: #f5a551\n}\n\n.tracking-status-deliveryoffice {\n    background-color: #f7dc6f\n}\n\n.tracking-status-delivered {\n    background-color: #4cbb87\n}\n\n.tracking-status-attemptfail {\n    background-color: #b789c7\n}\n\n.tracking-status-error,\n.tracking-status-exception {\n    background-color: #d26759\n}\n\n.tracking-status-expired {\n    background-color: #616e7d\n}\n\n.tracking-status-pending {\n    background-color: #ccc\n}\n\n.tracking-status-inforeceived {\n    background-color: #214977\n}\n\n.tracking-list {\n    border: 1px solid #e5e5e5\n}\n\n.tracking-item {\n    border-left: 1px solid #e5e5e5;\n    position: relative;\n    padding: 2rem 1.5rem .5rem 2.5rem;\n    font-size: .9rem;\n    margin-left: 3rem;\n    min-height: 5rem\n}\n\n.tracking-item:last-child {\n    padding-bottom: 4rem\n}\n\n.tracking-item .tracking-date {\n    margin-bottom: .5rem\n}\n\n.tracking-item .tracking-date span {\n    color: #888;\n    font-size: 85%;\n    padding-left: .4rem\n}\n\n.tracking-item .tracking-content {\n    padding: .5rem .8rem;\n    background-color: #f4f4f4;\n    border-radius: .5rem\n}\n\n.tracking-item .tracking-content span {\n    display: block;\n    color: #888;\n    font-size: 85%\n}\n\n.tracking-item .tracking-icon {\n    line-height: 2.6rem;\n    position: absolute;\n    left: -1.3rem;\n    width: 2.6rem;\n    height: 2.6rem;\n    text-align: center;\n    border-radius: 50%;\n    font-size: 1.1rem;\n    background-color: #fff;\n    color: #fff\n}\n\n.tracking-item .tracking-icon.status-sponsored {\n    background-color: rgb(43, 162, 188)\n}\n\n.tracking-item .tracking-icon.status-delivered {\n    background-color: #4cbb87\n}\n\n.tracking-item .tracking-icon.status-outfordelivery {\n    background-color: #f5a551\n}\n\n.tracking-item .tracking-icon.status-deliveryoffice {\n    background-color: #f7dc6f\n}\n\n.tracking-item .tracking-icon.status-attemptfail {\n    background-color: #b789c7\n}\n\n.tracking-item .tracking-icon.status-exception {\n    background-color: #d26759\n}\n\n.tracking-item .tracking-icon.status-inforeceived {\n    background-color: #214977\n}\n\n.tracking-item .tracking-icon.status-intransit {\n    color: #e5e5e5;\n    border: 1px solid #e5e5e5;\n    font-size: .6rem\n}\n\n@media(min-width:992px) {\n    .tracking-item {\n        margin-left: 10rem\n    }\n\n    .tracking-item .tracking-date {\n        position: absolute;\n        left: -10rem;\n        width: 7.5rem;\n        text-align: right\n    }\n\n    .tracking-item .tracking-date span {\n        display: block\n    }\n\n    .tracking-item .tracking-content {\n        padding: 0;\n        background-color: transparent\n    }\n}\n\n/*  //old ind */\n\n.track-info h3 {\n    font-size: 18px;\n    color: #1B1E1A;\n    margin-bottom: 30px\n}\n\n.track-info ul {\n    padding: 0;\n    margin: 0\n}\n\n.track-info ul li {\n    position: relative;\n    letter-spacing: .35px\n}\n\n.track-info ul li ul {\n    width: 80%\n}\n\n.track-info ul li ul li {\n    display: grid;\n    grid-template-columns: 120px 1fr;\n    padding: 15px 0;\n    font-size: 12px;\n    color: #6f6f6f;\n    font-weight: 400\n}\n\n.track-info ul li ul li::before {\n    top: 20px;\n    left: -30px;\n    position: absolute;\n    width: 12px;\n    height: 2px;\n    background: #959595;\n    content: \"\"\n}\n\n.track-info ul li ul li h4 {\n    margin: 0\n}\n\n.track-info ul li ul li strong,\n.track-info ul li ul li h4 {\n    color: #1B1E1A;\n    font-weight: 500\n}\n\n.track-info ul li ul li strong {\n    display: inline-block;\n    margin-bottom: 6px\n}\n\n.track-info ul li ul li b {\n    display: block;\n    color: #1B1E1A;\n    font-size: 13px;\n    font-weight: 500;\n    margin-bottom: 5px\n}\n\n.track-info>ul>li {\n    font-size: 16px;\n    font-weight: 700;\n    padding-left: 30px;\n    border-left: 2px solid #959595;\n}\n\n.track-info>ul>li::before {\n    top: 0 !important;\n}\n\n.track-info>ul>li:last-child::after {\n    bottom: -1px\n}\n\n\n.track .track-info>ul>li:last-child::after,\n.track .track-info>ul>li::before {\n    content: \"\";\n    height: 18px;\n    width: 18px;\n    background: #959595;\n    border: 3px solid #fff;\n    border-radius: 50%;\n    position: absolute;\n    left: -10px\n}\n\n.tracking_error {\n    padding: 15px;\n    font-weight: 500;\n    margin-top: 15px;\n    background: #ff2828;\n    text-align: center !important;\n    color: #fff !important;\n    border-radius: 4px\n}\n\n.track-not-found {\n    text-align: center;\n    margin-top: 15px\n}\n\n.track-not-found::before {\n    content: \"\";\n    /* background: url(/wp-content/themes/ecourier-2.0/images/not-found.svg) no-repeat center center; */\n    -webkit-background-size: 100%;\n    -ms-background-size: 100%;\n    background-size: 100%;\n    width: 150px;\n    height: 150px;\n    display: block;\n    margin: 30px auto\n}\n\n.track-not-found h3 {\n    color: #1B1E1A;\n    margin-bottom: 5px\n}\n\n.track-not-found h4 {\n    color: #3a3a3a;\n    font-weight: 400\n}\n\n.track-info>ul>li.active::before,\n.track-info>ul>li.active:last-child::after {\n    background: #0098b8;\n}\n.track-info>ul>li.active {\n    border-color: #0098b8;\n}\n\n.track-info>ul>li.active::before,\n.track-info>ul>li.active:last-child::after {\n    background: #0098b8;\n}\n\n.track-info>ul>li.active ul li::before {\n    background: #0098b8 !important;\n}\n\n.track .track-info>ul>li:last-child::after,\n.track .track-info>ul>li::before {\n    content: \"\";\n    height: 18px;\n    width: 18px;\n    background: #0098b8;\n    border: 3px solid #fff;\n    border-radius: 50%;\n    position: absolute;\n    left: -10px;\n}\n\n.track-info>ul>li::before {\n    top: 0;\n}\n\n*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n\n.track-info>ul>li {\n    font-size: 16px;\n    font-weight: 700;\n    padding-left: 30px;\n    border-left: 2px solid #959595;\n}\n\n.track-info ul li {\n    position: relative;\n    letter-spacing: .35px;\n}\n\nli {\n    list-style: none;\n}\n\nli {\n    text-align: -webkit-match-parent;\n}\n\nul {\n    list-style-type: disc;\n}\n\n.track-info ul li {\n    position: relative;\n    letter-spacing: .35px;\n}\n\n.track-content {\n    padding: 30px;\n    background: #fff;\n    border-radius: 6px;\n    padding-top: 10px;\n}\n\n.track {\n    position: relative;\n    z-index: 1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
